import { render, staticRenderFns } from "./SkuData.vue?vue&type=template&id=05f40db0&scoped=true&"
import script from "./SkuData.vue?vue&type=script&lang=js&"
export * from "./SkuData.vue?vue&type=script&lang=js&"
import style0 from "./SkuData.vue?vue&type=style&index=0&id=05f40db0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f40db0",
  null
  
)

export default component.exports